import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'templateName',
  standalone: false,
})
export class WkTemplateNamePipe implements PipeTransform {
  transform(templateName: string) {
    return templateName.length > 65
      ? `${templateName.slice(0, 65)}...`
      : templateName;
  }
}
